export default "__VITE_ASSET__CEqpdfXk__"